import React, { useState, useRef, useEffect } from 'react';
import { Box, CircularProgress } from '@mui/material';

const LazyImage = ({ 
  src, 
  alt, 
  sx = {}, 
  placeholder = null,
  loading = 'lazy',
  ...props 
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isInView, setIsInView] = useState(false);
  const imgRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (imgRef.current) {
      observer.observe(imgRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const handleLoad = () => {
    setIsLoaded(true);
  };

  return (
    <Box
      ref={imgRef}
      sx={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        ...sx
      }}
      {...props}
    >
      {isInView && (
        <>
          <img
            src={src}
            alt={alt}
            loading={loading}
            onLoad={handleLoad}
            style={{
              opacity: isLoaded ? 1 : 0,
              transition: 'opacity 0.3s ease-in-out',
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }}
          />
          {!isLoaded && (
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                zIndex: 1
              }}
            >
              {placeholder || <CircularProgress size={24} />}
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default LazyImage;
